export const PAGE_VIEW_EVENT = 'page_view';
export const SITE_NAME = 'website-booking';

export const FIND_A_SESSION = 'Find a session';
// export const SELECT_SPECIALTY = 'select-specialty';
export const NEW_PATIENT_REGISTRATION = 'New patient registration';
export const UPLOAD_REFERRAL = 'Upload referral / supporting documents';
export const MEDICARE_DETAILS = 'Medicare details';
export const PAYMENT_CONSENT_AND_POLICY = 'Payment consent and policy';
export const CONFIRM_BOOKING = 'Confirm your booking';
export const APPOINTMENT_CONFIRMATION = 'Appointment confirmation';
// export const REFERRAL_DETAILS = 'referral-details';
// export const GP_DETAILS = 'gp-details';
